import React, { useState } from "react";
import {
  Button,
  Modal,
  Text,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Flex,
  Box,
  FormControl,
  FormLabel,
  Icon,
  Input,
  Textarea,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FaPlus, FaFileAlt, FaTags } from "react-icons/fa";
import Table_category from "./Table_category";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const EventCategoryCreate = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  // Form state
  const [eventMaster, setEventMaster] = useState("");
  const [description, setDescription] = useState("");

  // Handle form submission
  const handleCreateEvent = async () => {
    if (!eventMaster || !description) {
      toast({
        title: "Error",
        description: "Please fill in both Category Name and Description.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const data = {
      user_id: sessionStorage.getItem("user_id"), // Replace with the actual logged-in user's ID
      school_id: sessionStorage.getItem("school_id"), // Replace with the actual school ID
      event_master: eventMaster,
      description: description,
    };

    try {
      const response = await fetch(
        `${BASE_URL}/admin/events/event_master/create.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();
      console.log("result", result);

      if (result.success) {
        toast({
          title: "Success",
          description: result.message,
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: "Error",
          description: result.message,
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <div>
      {/* Flex Container to align Button and Table */}
      <Flex
        direction="row"
        align="flex-start" /* Align items at the top */
        justify="space-between"
        wrap="nowrap"
        w="100%"
      >
        <Button
          leftIcon={<FaPlus />}
          colorScheme="purple"
          onClick={onOpen}
          size={{ base: "xs", md: "md" }}
          /* Adjust the button upwards */
        >
          <Text display={{ base: "none", md: "inline" }}>Category</Text>{" "}
        </Button>
        <Box flex="1" ml={4}>
          <Table_category />
        </Box>
      </Flex>

      {/* Chakra UI Modal */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Create Event Category
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>
                {" "}
                <Icon as={FaTags} mr={1} color="teal.500" />
                Category Name
              </FormLabel>
              <Input
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={eventMaster}
                onChange={(e) => setEventMaster(e.target.value)}
                placeholder="Enter category name"
              />
            </FormControl>
            <FormControl>
              <FormLabel>
                {" "}
                <Icon as={FaFileAlt} mr={1} color="teal.500" />
                Description
              </FormLabel>
              <Textarea
                value={description}
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleCreateEvent}
            >
              Save
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EventCategoryCreate;
